export const CHART_EXAMPLE_MOCK = [
  { name: 'Group A long name for test', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 10 },
]

export const SUMMARY_STATISTIC_DATA = [
  { name: 'All', value: 200 },
  { name: 'Tenants', value: 136 },
  { name: 'Landlords', value: 64 },
  { name: 'Online', value: 52 },
  { name: 'Invited', value: 73 },
  { name: 'Blocked', value: 50 },
  { name: 'Imported', value: 35 },
  { name: 'Telephone', value: 60 },
  { name: 'Email', value: 60 },
  { name: 'Telephone & Email', value: 60 },
  { name: 'None', value: 20 },
]

export const ROLE_STATISTIC_DATA = [
  { name: 'All', value: 200 },
  { name: 'Tenants', value: 136 },
  { name: 'Landlords', value: 64 },
]

export const STATUS_STATISTIC_DATA = [
  { name: 'All', value: 200 },
  { name: 'Online', value: 52 },
  { name: 'Invited', value: 73 },
  { name: 'Blocked', value: 50 },
  { name: 'Imported', value: 35 },
]

export const CONTACT_STATISTIC_DATA = [
  { name: 'All', value: 200 },
  { name: 'Telephone', value: 60 },
  { name: 'Email', value: 60 },
  { name: 'Telephone & Email', value: 60 },
  { name: 'None', value: 20 },
]

export const CHART_AREA_EXAMPLE_SERIES = [
  { color: 'var(--color-info)', dataKey: 'opened', name: 'Opened' },
  { color: 'var(--color-success)', dataKey: 'closed', name: 'Closed' },
]

export const CHART_AREA_EXAMPLE_MOCK = [
  { closed: 8, name: '01/09', opened: 12 },
  { closed: 11, name: '02/09', opened: 15 },
  { closed: 9, name: '03/09', opened: 10 },
  { closed: 14, name: '04/09', opened: 18 },
  { closed: 12, name: '05/09', opened: 16 },
  { closed: 17, name: '06/09', opened: 21 },
  { closed: 15, name: '07/09', opened: 19 },
]

export const CHART_SPARKLINE_EXAMPLE_MOCK = [
  { name: '01/09', value: 3.1 },
  { name: '05/09', value: 2.9 },
  { name: '09/09', value: 3 },
  { name: '13/09', value: 2.7 },
  { name: '17/09', value: 2.6 },
  { name: '21/09', value: 2.5 },
  { name: '25/09', value: 2.4 },
  { name: '29/09', value: 2.4 },
]
